/* Balanz scroll reveal */
(() => {
  const selector = '.balanz-reveal, .balanz-reveal--image';

  function revealImmediately(root = document) {
    root.querySelectorAll(selector).forEach((el) => {
      el.classList.add('is-visible');
    });
  }

  function initReveal(root = document) {
    const elements = Array.from(root.querySelectorAll(selector))
      .filter((el) => !el.dataset.balanzRevealReady);

    if (!elements.length) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      elements.forEach((el) => {
        el.dataset.balanzRevealReady = 'true';
        el.classList.add('is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        });
      },
      {
        threshold: 0.12,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    elements.forEach((el) => {
      el.dataset.balanzRevealReady = 'true';
      try {
        observer.observe(el);
        el.classList.add('balanz-reveal-ready');
      } catch (_) {
        el.classList.add('is-visible');
      }
    });
  }

  function boot() {
    try { initReveal(document); } catch (_) { revealImmediately(document); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    try { initReveal(event.target); } catch (_) { revealImmediately(event.target); }
  });

  document.addEventListener('shopify:section:select', (event) => {
    revealImmediately(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target.closest('[id^="shopify-section-"]') || event.target;
    revealImmediately(section);
  });
})();
